<template>
  <div>
    <!-- <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin> -->
    <v-main>
      <div style=" overflow-x: hidden">
        <v-row style="padding:1% 2%; height: 70px;">
          <v-col xs="10" sm="10" md="10" lg="10">
            <h2>รับของรางวัล</h2>
          </v-col>
          <!-- <v-col right xs="2" sm="2" md="2" lg="2" class="displayxs">
            <v-btn large outlined color="indigo">
              รับของรางวัล
            </v-btn>
            <v-btn large outlined color="indigo">
              ยกเลิก
            </v-btn>
          </v-col> -->
        </v-row>
        <v-divider style="padding-top:0; magin: 0px 0px"></v-divider>
        <v-container>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-row style="padding-top: 20px;justify-content: center;">
              <v-col cols="12" xs="12" sm="12" md="6" lg="6">
                <v-row>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    class="padding-colH"
                  >
                    <p style="margin: 0px 0px">
                      รหัสของรางวัล <span style="color: red;">*</span>
                    </p>
                  </v-col>
                  <v-col
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding:0px 0px"
                  >
                    <v-text-field
                      v-model="checkCode"
                      label=""
                      solo
                      required
                      :append-outer-icon="'mdi-magnify'"
                      @click:append-outer="check()"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="status === true">
                  <v-container>
                    <v-card style="width:100%">
                      <v-container>
                        <v-row>
                          <v-col>
                            <v-img
                              :src="d.pictureUrl"
                              :aspect-ratio="16 / 9"
                            ></v-img>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col>
                            <h3>{{ d.name }}</h3>
                            <p>
                              {{
                                d.endDate !== null
                                  ? "หมดอายุ  " + format_dateNotime(d.endDate)
                                  : null
                              }}
                            </p>
                            <!-- <v-divider></v-divider> -->
                            <v-expansion-panels>
                              <v-expansion-panel>
                                <v-expansion-panel-header>
                                  เงื่อนไข
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                  {{ d.description }}
                                </v-expansion-panel-content>
                              </v-expansion-panel>
                            </v-expansion-panels>
                            <br />
                            <v-textarea
                              label="หมายเหตุ"
                              style="padding: 0px !important;"
                              auto-grow
                              rows="1"
                              name="input-7-4"
                              outlined
                              dense
                              v-model="formUpdate.remark"
                            ></v-textarea>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col>
                            <v-btn dark block color="#173053" @click="submit()"
                              >ยืนยัน</v-btn
                            >
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card>
                  </v-container>
                </v-row>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import moment from 'moment'
export default {
  components: {
    moment
  },
  data () {
    return {
      session: this.$session.getAll(),
      //   path: '/qrcode/', // Path Model
      //   returnLink: '/Tool/CollectQRCode',
      valid: true,
      checkCode: '',
      d: [],
      status: false,
      DateNow: new Date(),
      formUpdate: {
        redeemStatus: 'use',
        remark: '',
        useDate: moment().format('YYYY-MM-DD HH:mm:ss')
      }
    }
  },
  mounted () {},
  methods: {
    check () {
      axios
        .get(
          this.DNS_IP +
            '/rewardCode/getData?shopId=' +
            this.session.data.shopId +
            '&redeemStatus=get&rewardCode=' +
            this.checkCode
        )
        .then(res => {
          let rs = res.data
          console.log('res', res.data)
          if (rs.message === 'No data found' || rs.status === false) {
            this.$swal(
              'ข้อมูลไม่ถูกต้อง',
              'กรุณากรอกรหัสให้ถูกต้อง',
              'warning'
            )
            this.checkCode = ''
          } else {
            console.log('res', res.data)
            this.d = rs[0]
            console.log('moment', this.formUpdate.useDate)
            this.status = true
          }
        })
    },
    submit () {
      //   console.log(this.format_dateNotime(this.d.endDate));

      var date = moment(this.d.endDate).format('YYYY-MM-DD')
      var todaysDate = moment().format('YYYY-MM-DD')
      // console.log(moment('2024-05-03').format("YYYY-MM-DD") >= moment(this.DateNow).format("YYYY-MM-DD"))
      // console.log(todaysDate)
      // console.log(date)
      // console.log(todaysDate > date)
      // console.log(todaysDate < date)
      //    alert("ยืนยัน");
      if (date >= todaysDate) {
        let ID = this.d.rewardCodeId
        axios
          .post(this.DNS_IP + '/rewardCode/edit/' + ID, this.formUpdate)
          .then(async response => {
            // Debug response
            console.log('editDataGlobal DNS_IP + PATH + "edit"', response)

            this.$swal('สำเร็จ', 'แลกของรางวัลสำเร็จแล้ว', 'success')

            this.clear()
          })
      } else {
        this.$swal(
          'ของรางวัลหมดอายุ',
          'ไม่สามารถแลกของรางวัลได้ เนื่องจากเกินวันที่กำหนดแลกของ',
          'warning'
        )
      }
      //
    },
    clear () {
      this.checkCode = ''
      this.status = false
      this.d = []
    }
  }
}
</script>
<style scoped>
.v-text-field--solo > .v-input__control > .v-input__slot {
  background: #f2f4f9 !important;
}
.padding-colH {
  padding: 5px 15px 0px;
}
.v-expansion-panel-header {
  background-color: white !important;
  color: black !important;
  font-weight: bold !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Master/Redeem.vue